import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar } from '../../../../global/commonStyle';

const ActionDiv = styled.div`
  display: flex;
  gap: var(--space-8);
`;

const IconDiv = styled.div`
  display: flex;
  padding: var(--space-5);
  cursor: pointer;
  svg {
    fill: var(--text-secondary);
    &:hover {
      fill: var(--text-primary);
    }
  }
`;

const MainSection = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-24);
`;

const TableDiv = styled.div`
  width: 100%;
  gap: var(--space-0);
  padding: var(--space-0);
  border-radius: var(--border-radius-8);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  overflow: hidden;
  ${mobile_xl(css`
    ${HideScrollbar}
  `)}

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
  }
  thead {
    background-color: var(--background-tertiary);
  }

  thead th,
  td {
    text-align: left;
    color: var(--text-secondary);
    padding: var(--space-12) var(--space-20) var(--space-12) var(--space-11);
    border-bottom: 0.5px solid var(--border-primary);
    ${Typography.body_md_medium}
    ${mobile_xl(css`
      :first-child {
        padding-left: var(--space-12);
      }
    `)}
  }
  thead th {
    position: relative;
  }
  th:nth-child(1),
  td:nth-child(1) {
    width: 135px;
    ${mobile_xl(css`
      width: 164px;
    `)}
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 120px;
    ${mobile_xl(css`
      width: 171px;
    `)}
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 80px;
    ${mobile_xl(css`
      width: 121px;
    `)}
  }
  thead th:nth-child(2)::before {
    content: '';
    position: absolute;
    left: 0;
    top: var(--space-12);
    height: 20px;
    width: 0.5px;
    background: var(--border-primary);
  }
  thead th:nth-child(2)::after {
    content: '';
    position: absolute;
    right: 0;
    top: var(--space-12);
    height: 20px;
    width: 0.5px;
    background: var(--border-primary);
  }
  tbody td {
    color: var(--text-primary);
    :first-child {
      max-width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  tbody tr:last-child td {
    border-bottom: none;
  }
`;

const ButtonSection = styled.div`
  width: max-content;
  display: flex;
  justify-content: center;
`;

export { ActionDiv, IconDiv, TableDiv, ButtonSection, MainSection };
